import { stringHelpers } from '@approvalmax/utils';

const delimiter = '-';

export const transform = (value: string) => {
    if (value.length === 3) {
        return `${value}${delimiter}`;
    }

    if (value.length > 4) {
        const [left, right] = value.split(delimiter);

        return `${stringHelpers.escapeSpecificExpressions(left, [/[^0-9]/g])}${delimiter}${stringHelpers.escapeSpecificExpressions(right, [/[^0-9]/g])}`;
    }

    return stringHelpers.escapeSpecificExpressions(value, [/[^0-9]/g]);
};
